import React from 'react'
import { StaticQuery, graphql } from 'gatsby';
import { withPreview } from 'gatsby-source-prismic-graphql'
import FacebookDark from '../../assets/facebook-dark.svg'
import FacebookLight from '../../assets/facebook-light.svg'
import Box from '../Box'
import Icon from './Icon'

const query = graphql`
  {
    prismic {
      allSettings {
        edges {
          node {
            facebook_url
          }
        }
      }
    }
  }
`

export default ({
  color = 'grey4',
  variant = 'dark',
  ...rest
}) => (
  <StaticQuery
    query={query}
    render={withPreview(({
      prismic: {
        allSettings: {
          edges: [{
            node: {
              facebook_url,
            },
          }],
        },
      },
    }) => (
      <Box
        display='flex'
        justifyContent='center'
      >
        <Icon
          component={variant === 'dark' ? FacebookDark : FacebookLight}
          href={facebook_url}
          alt='Facebook'
          {...rest}
        />
      </Box>
    ), query)}
  />
)
